<app-alerts />

<app-warehouse-release-form
  (submitSuccessEvent)="handleSubmitSuccessEvent($event)"
  [fileUploadVisibility]="fileUploadVisibility()" />
